var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgType2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke:#353841;stroke-width:1.5px;}.b{fill:#cad0e4;}.c{fill:#353841;}.d,.f{stroke:none;}.e{fill:none;}.f{fill:#71778a;}.g{filter:url(#m);}.h{filter:url(#k);}.i{filter:url(#i);}.j{filter:url(#g);}.k{filter:url(#e);}.l{filter:url(#c);}.m{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 35.186,
    y: 37.309,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 22.701,
    y: 37.309,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 41.428,
    y: 27.5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 28.943,
    y: 27.5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 16.459,
    y: 27.5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 23.593,
    y: 19.474,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 36.078,
    y: 19.474,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-243 -577)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-6326-3134.437a21.225,21.225,0,0,1-14.849-5.949,19.851,19.851,0,0,1-6.15-14.364,19.562,19.562,0,0,1,2.286-9.227A20.7,20.7,0,0,1-6338.6-3171h25.2a20.692,20.692,0,0,1,6.111,7.023,19.584,19.584,0,0,1,2.288,9.227,19.858,19.858,0,0,1-6.151,14.364A21.225,21.225,0,0,1-6326-3134.437Z",
    transform: "translate(6606 3767.016)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, 243, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(38.19 40.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, 243, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(25.7 40.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, 243, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(44.43 30.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, 243, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(31.94 30.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, 243, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(19.46 30.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, 243, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(26.59 22.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 4 7.25 C 2.207940101623535 7.25 0.75 5.792059898376465 0.75 4 C 0.75 2.207940101623535 2.207940101623535 0.75 4 0.75 C 5.792059898376465 0.75 7.25 2.207940101623535 7.25 4 C 7.25 5.792059898376465 5.792059898376465 7.25 4 7.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 4 1.5 C 2.621500015258789 1.5 1.5 2.621500015258789 1.5 4 C 1.5 5.378499984741211 2.621500015258789 6.5 4 6.5 C 5.378499984741211 6.5 6.5 5.378499984741211 6.5 4 C 6.5 2.621500015258789 5.378499984741211 1.5 4 1.5 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "matrix(1, 0, 0, 1, 243, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(39.08 22.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 4 7.25 C 2.207940101623535 7.25 0.75 5.792059898376465 0.75 4 C 0.75 2.207940101623535 2.207940101623535 0.75 4 0.75 C 5.792059898376465 0.75 7.25 2.207940101623535 7.25 4 C 7.25 5.792059898376465 5.792059898376465 7.25 4 7.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M 4 1.5 C 2.621500015258789 1.5 1.5 2.621500015258789 1.5 4 C 1.5 5.378499984741211 2.621500015258789 6.5 4 6.5 C 5.378499984741211 6.5 6.5 5.378499984741211 6.5 4 C 6.5 2.621500015258789 5.378499984741211 1.5 4 1.5 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2);
export default __webpack_public_path__ + "static/media/type2.f333dcfaaa42c6d14df4d6ba6f741b45.svg";
export { ForwardRef as ReactComponent };